// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OnlineParticipants from './components/OnlineParticipants';
import Participants from './components/Participants';
import PrizeDraw from './pages/PrizeDraw';
function App() {
	return (
		<Router>
			<Routes>
				<Route path="/participants" element={<OnlineParticipants />} />
				<Route
					path="/participants/:mid"
					element={<OnlineParticipants />}
				/>
				<Route
					path="/participants/past/:mid"
					element={<Participants />}
				/>
				<Route
					path="/participants/past/:mid/:start/:end"
					element={<Participants />}
				/>
				<Route path="/prize_draw/:mid" element={<PrizeDraw />} />
			</Routes>
		</Router>
	);
}

export default App;
